import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Save, SlidersHorizontal } from "lucide-react";
import storage from "../assets/js/Global";
import { logout } from "../services/authService";

const Settings = () => {
  const navigate = useNavigate();

  return (
    <main className="app-wrapper url-list-page">
      <div className="container-fluid py-3">

        {/* General Preferences */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body p-4">
            <div className="d-flex align-items-center gap-3 mb-3">
              <div className="ais-card-icon ais-card-icon--amber">
                <SlidersHorizontal size={17} />
              </div>
              <div>
                <h5 className="mb-1 fw-semibold">General Preferences</h5>
                <p className="text-muted mb-0 small">Set how the dashboard behaves for your team.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer actions */}
        <div className="d-flex justify-content-between align-items-center">
          <button
            type="button"
            className="btn btn-outline-danger d-flex align-items-center gap-2"
            onClick={async () => {
              try { await logout(); } catch {}
              localStorage.clear();
              navigate("/login");
            }}
          >
            <LogOut size={16} />
            Logout
          </button>
          <button className="btn btn-primary d-flex align-items-center gap-2">
            <Save size={16} />
            Save Changes
          </button>
        </div>

      </div>
    </main>
  );
};

export default Settings;
